import {
  ChangeDetectionStrategy,
  Component,
  inject,
  output,
  viewChild,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { CdkPortal, PortalModule } from '@angular/cdk/portal';
import { Overlay, OverlayConfig } from '@angular/cdk/overlay';

@Component({
  selector: 'app-dialog',
  imports: [PortalModule],
  templateUrl: './dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Dialog implements OnInit, AfterViewInit, OnDestroy {
  closed = output<void>();
  portal = viewChild<CdkPortal>(CdkPortal);

  readonly #overlay = inject(Overlay);
  overlayConfig = new OverlayConfig({
    hasBackdrop: true,
    positionStrategy: this.#overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically(),
    scrollStrategy: this.#overlay.scrollStrategies.block(),
    width: '600px',
    maxWidth: '100%',
  });
  overlayRef = this.#overlay.create(this.overlayConfig);

  ngOnInit(): void {
    this.overlayRef.backdropClick().subscribe(() => {
      this.closed.emit();
    });
  }

  ngAfterViewInit(): void {
    this.overlayRef?.attach(this.portal());
  }

  ngOnDestroy(): void {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
  }
}
